import { ScrollbarPlugin } from 'smooth-scrollbar'

export class switchToXAxis extends ScrollbarPlugin {
  static pluginName = 'horizontalScroll'

  transformDelta(delta, fromEvent) {
    if (!/wheel || keydown/.test(fromEvent.type)) return delta

    const { x, y } = delta

    return {
      x: Math.abs(x) > Math.abs(y) ? x : y,
      y: 0,
    }
  }
}

export class EdgeEasingPlugin extends ScrollbarPlugin {
  static pluginName = 'edgeEasing'

  _remainMomentum = {
    x: 0,
    y: 0,
  }

  transformDelta(delta, fromEvent) {
    if (fromEvent.type === 'keydown') return delta
    const { limit, offset } = this.scrollbar

    const x = this._remainMomentum.x + delta.x
    const y = this._remainMomentum.y + delta.y

    // clamps momentum within [-offset, limit - offset]
    this.scrollbar.setMomentum(
      Math.max(-offset.x, Math.min(x, limit.x - offset.x)),
      Math.max(-offset.y, Math.min(y, limit.y - offset.y)),
    )

    return {
      x: 0,
      y: 0,
    }
  }

  onRender(remainMomentum) {
    Object.assign(this._remainMomentum, remainMomentum)
  }
}
